var _circle, _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitePlusOnGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#484848"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.46143,
    y: 3.29395,
    width: 5.06338,
    height: 5.16267,
    stroke: "#979797",
    strokeOpacity: 0.01,
    strokeWidth: 0.2464
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16269 6.04899L7.96416 6.04897C8.0579 6.04905 8.13403 5.97143 8.13395 5.87585C8.13395 5.78019 8.05798 5.70273 7.96416 5.70273L6.16269 5.70275L6.16271 3.86595C6.16271 3.7703 6.08674 3.69284 5.99292 3.69284C5.89918 3.69276 5.82305 3.77038 5.82313 3.86596L5.82311 5.70275L4.02164 5.70277C3.9279 5.70269 3.85177 5.78031 3.85185 5.87589C3.85185 5.92372 3.8709 5.96698 3.90164 5.99832C3.93238 6.02966 3.97473 6.04901 4.02164 6.04901L5.82311 6.04899L5.82309 7.88579C5.82309 7.93362 5.84214 7.97687 5.87288 8.00822C5.90362 8.03956 5.94597 8.0589 5.99288 8.0589C6.08662 8.05898 6.16275 7.98136 6.16267 7.88578L6.16269 6.04899",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16269 6.04899L7.96416 6.04897C8.0579 6.04905 8.13403 5.97143 8.13395 5.87585C8.13395 5.78019 8.05798 5.70273 7.96416 5.70273L6.16269 5.70275L6.16271 3.86595C6.16271 3.7703 6.08674 3.69284 5.99292 3.69284C5.89918 3.69276 5.82305 3.77038 5.82313 3.86596L5.82311 5.70275L4.02164 5.70277C3.9279 5.70269 3.85177 5.78031 3.85185 5.87589C3.85185 5.92372 3.8709 5.96698 3.90164 5.99832C3.93238 6.02966 3.97473 6.04901 4.02164 6.04901L5.82311 6.04899L5.82309 7.88579C5.82309 7.93362 5.84214 7.97687 5.87288 8.00822C5.90362 8.03956 5.94597 8.0589 5.99288 8.0589C6.08662 8.05898 6.16275 7.98136 6.16267 7.88578L6.16269 6.04899",
    stroke: "white",
    strokeWidth: 0.946176
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlusOnGrey);
export default __webpack_public_path__ + "static/media/white-plus-on-grey.7cd779569c9337ee26a8c2ed0c189679.svg";
export { ForwardRef as ReactComponent };